import React, { useCallback, useContext, useState } from 'react';

// GLOBAL VARIABLES
import { UPLOAD } from 'defaults.js';

// GLOBAL FUNCTIONS
import { modalFunctions } from 'functions.js';

// CONTEXT
import { UploadContext } from '../helpers/uploadContext';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// LOCAL COMPONENTS
import UploadModal from './UploadModal';

// STYLES
import styles from './uploadButton.module.scss';

// MAIN COMPONENT
const UploadButton = ({
  button: {
    as: Component = Button, //
    ...button
  } = {}, //
  disabled,
  multiple = UPLOAD.multple,
  readonly,
  ...props
}) => {
  // STATE
  const [showUpload, setShowUpload] = useState(false);

  // CONTEXT
  const { uploads } = useContext(UploadContext) || {};

  // CALLBACKS
  const handleClick = useCallback(() => {
    if (uploads?.length && !multiple) {
      modalFunctions.add({
        type: 'confirmation',
        title: 'Confirm Overwrite',
        body: <div className="text-center">Are you sure want to overwrite this attachment?</div>,
        closeButton: true,
        spacing: 'sm',
        continueButton: {
          label: 'Confirm',
          onClick: () => setShowUpload(true)
        }
      });
    } else {
      setShowUpload(true);
    }
  }, [multiple, uploads]);

  // RENDER
  return readonly ? null : (
    <>
      <Component
        className={styles.button}
        variant={UPLOAD.variant}
        label="Upload"
        icon="upload"
        onClick={handleClick}
        fullWidth={UPLOAD.fullWidth}
        disabled={disabled}
        {...button}
      />
      <UploadModal {...props} multiple={multiple} show={showUpload} onClose={() => setShowUpload(false)} />
    </>
  );
};

export default UploadButton;
